var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef } from 'react';
import { FactoryComponent } from '../../../factory';
import withDesign from '../../../hocs/withDesign';
import { Icon } from '../Icon';
import { TranslatedText } from '../TranslatedText';
import { StyledCheckboxInput, StyledCheckboxWrapper } from './styled';
export var CheckboxInputComponent = forwardRef(function (_a, ref) {
    var components = _a.components, text = _a.text, checkedIcon = _a.checkedIcon, schema = _a.schema, checked = _a.checked, id = _a.id, name = _a.name, value = _a.value, props = __rest(_a, ["components", "text", "checkedIcon", "schema", "checked", "id", "name", "value"]);
    return (_jsxs(StyledCheckboxWrapper, __assign({ schema: schema }, { children: [_jsx(StyledCheckboxInput, __assign({ ref: ref, id: id !== null && id !== void 0 ? id : name, name: name }, props)), _jsx(FactoryComponent, __assign({ as: "label", htmlFor: name, design: components.checkbox, active: checked }, { children: checked && _jsx(Icon, __assign({ design: components.checkedIcon }, checkedIcon)) })), components.text ? (_jsx(TranslatedText, __assign({ htmlFor: name, design: components.text, active: checked }, text))) : null] })));
});
export var CheckboxInput = withDesign(CheckboxInputComponent);
CheckboxInput.displayName = 'CheckboxInput';
export * from './CheckboxInput.types';
